<template>
    <div class="__l">
        <div class="flex justify-between mb-8 items-center">
            <div>
                <h1 class="text-4xl tracking-widest uppercase font-bold text-gray-700">Blog & Resources</h1>
            </div>
            <div>
                <button class="btn-primary" type="button" @click="createPost">Create Blog Post</button>
            </div>
        </div>

        <input type="text" v-model="search" class="form-field py-4 px-6" ref="searchbar" placeholder="Search for Posts"
               @keyup.enter="handleSearch">

        <div class="results-list">
            <div class="results-row">
                <div class="results-head" data-width="10%">ID</div>
                <div class="results-head" data-width="60%">Title</div>
                <div class="results-head" data-width="20%">Date</div>
                <div class="results-head" data-width="10%">State</div>
            </div>
            <template v-if="results.data">
                <div class="results-row" v-for="(result, index) in results.data" :key="index"
                     @click="handleSelectedPost(result)">
                    <div class="results-cell" data-width="10%">{{ result.blog_id }}</div>
                    <div class="results-cell truncate" data-width="60%">{{ result.blog_title }}</div>
                    <div class="results-cell" data-width="20%">{{ formatDateShort(result.blog_datetime) }}</div>
                    <div class="results-cell text-green" data-width="10%" v-if="result.blog_active == 1">Published</div>
                    <div class="results-cell text-red" data-width="10%" v-if="result.blog_active != 1">Unpublished</div>
                </div>
                <pagination v-model="page" :records="results.total" :per-page="25"
                            @paginate="loadData"></pagination>
            </template>
            <div class="results-row" v-if="!results.data">
                <div class="results-span text-center" data-width="100%">
                    <p>No results found</p>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
import BlogView from './View'
import Pagination from 'v-pagination-3'

export default {
    name: 'Blogs',
    props: {
        //
    },
    data() {
        return {
            search: null,
            results: {},
            page: 1,
        }
    },
    components: {
        Pagination,
        BlogView,
    },
    mounted() {
        window.setTimeout(function () {
            this.$refs.searchbar.focus()
        }.bind(this), 100)

        this.setMetaTitle('List Blog Posts | JournoLink Control')
    },
    methods: {
        handleSearch() {
            this.loadData()
        },
        /**
         * Load the results from the data provider
         *
         * @return {void}
         */
        loadData() {
            axios.get(route('blogs.list'), {
                params: {
                    term: this.search,
                    page: this.page,
                },
            })
                .then(response => {
                    this.results = response.data.results
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle the selection of a BlogPost
         *
         * @param  {Object} post
         * @return {void}
         */
        handleSelectedPost(post) {
            this.$router.push({name: 'blog.show', params: {blogId: post.blog_id}})
        },
        /**
         * Create a new BlogPost
         *
         * @return {void}
         */
        createPost() {
            this.$router.push({name: 'blog.create'})
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to && to.name === 'blog.list') {
            this.setMetaTitle('List Blog Posts | JournoLink Control')
            this.loadData()
        }

        if (to && to.params.newPost) {
            window.setTimeout(() => {
                this.handleSelectedPost(to.params.newPost)
            }, 500)

            next()
        }

        next()
    },
}
</script>

<style lang="less">

</style>
